<template>
  <div v-bind:class="{ isHidden: hide_bookmark }">
    <div class="d-flex justify-content-between text-white fs-26" style="float: right;">
        <div v-if="is_saved">
            <i class="fa-solid fa-bookmark fa-sm"></i>
        </div>
        <div v-else class="cursor-pointer bookmark-div" @click="dialogBookmark = true">
            <i class="fa-regular fa-bookmark fa-sm"></i>
            <i class="fa-solid fa-bookmark fa-sm"></i>
        </div>
    </div>


    <!-- Dialog - Save/Bookmark -->
    <v-dialog
        v-model="dialogBookmark"
        content-class="bookmark-dialog"
        max-width="400px"
        scrollable
        transition="scroll-x-transition"
        overlay-opacity="0.8"
        overlay-color="#000"
    >
        <v-card>
            <v-card-title>
                <div class="w-100 d-flex justify-content-between align-items-center">
                <h2 class="mb-0">Save Artwork</h2>

                <a @click="dialogBookmark = false" class="btn btn-close-modal" text>
                    <i class="fas fa-times"></i>
                </a>
                </div>
            </v-card-title>

            <v-card-text class="py-0">
                <v-container class="artwork-save-input-wrap">
                    <v-row>
                        <form action="" method="POST" @submit.prevent="handleEmailArtwork">
                        <v-col cols="12">
                            <v-row class="mt-2">
                                <v-col cols="12">
                                    <p class="fs-16"><strong>We'll send you this page to access later!</strong></p>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="9" class="p-0 pr-2">
                                    <v-text-field
                                        outlined
                                        v-model="form.email"
                                        placeholder="enter email"
                                        class="text-field save-email-input"
                                        type="email"
                                        required
                                        ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="p-0">
                                    <button
                                        submit
                                        class="btn btn-white"
                                    >
                                        submit
                                    </button>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" class="text-white mb-3">
                                    <div class="d-flex">
                                        <p>Would you like to keep in touch with the creator?</p>
                                        <div class="ml-1">
                                            <input type="checkbox" v-model="form.is_keep_in_touch" style="min-height: 28px !important; height: 28px !important;" />
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>

                        </v-col>
                        </form>
                    </v-row>

                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>


  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    artwork: {
      type: Object,
    },
    hide_bookmark: Boolean,
  },
  mounted() {
    this.getSavedEmail();
    this.getIsSavedArtwork();
    if(this.hidden) {
      console.log('hiding the bookmark');
    }
  },
  data() {
    return {
      dialogBookmark: false,
      is_saved: false,
      form: {
        email: '',
        is_keep_in_touch: false,
        artwork_id: this.artwork.id,
      },
      hidden: this.hide_bookmark,
    };
  },
  methods: {
    async getSavedEmail() {
        await axios
        .get('/api/v1/frontend/saved-email')
        .then((response) => {
            if(response.data.email) {
                this.form.email = response.data.email;
            }
        });
    },

    async getIsSavedArtwork() {
        await axios
        .get('/api/v1/frontend/is-saved-artwork/'+this.artwork.id)
        .then((response) => {
            if(response.data.is_saved) {
                this.is_saved = response.data.is_saved;
            }
        });
    },

    async handleEmailArtwork() {
        this.dialogBookmark = false;

        await axios
        .post("/api/v1/frontend/save-artwork", this.form)
        .then((response) => {
            console.log(response);
            if(response.data.success == 'failed') {
                Vue.swal("", "There was an error saving the artwork. Please try again.", "error");
            } else {
                Vue.swal({
                    title: "",
                    text: "Artwork Saved",
                    icon: "success",
                    toast: true,
                    position: "top-end",
                    timer: 2000,
                    showConfirmButton: false,
                });

                this.is_saved = true;
                this.dialogBookmark = false;
            }

        })
        .catch(function (e) {
          if (e.response.status == 422) {
            var errorText = "";
            if (e.response.data.errors) {
              Object.entries(e.response.data.errors).forEach(([key, value]) => {
                value.forEach((errorMessage) => {
                  errorText += "" + errorMessage + " <br>";
                });
              });
            } else {
              errorText += e.response.data.message;
            }
            Vue.swal("", errorText, "error");
            return e.response;
          } else {
            Vue.swal("", "Server error", "error");
          }
        });

    },
  },
};
</script>
